import React from 'react';
import RecorderV1 from 'components/organismos/RecorderV1';

const RecorderPage_v1 = () => (
  <RecorderV1/>
);

export default RecorderPage_v1;
